// removed by extract-text-webpack-plugin
module.exports = {"this":"TextWithEntities__this___3dTe6"};


//////////////////
// WEBPACK FOOTER
// ./src/components/styles/TextWithEntities.css
// module id = 989
// module chunks = 4